import {
  UniversalContext,
  useUniversalContext,
} from "@cxc/react-universal-components";
import { useCanadaPopUp } from "../components/AppProvider/UseCanadaPopUp";
import { htmlReactParser } from "./htmlReactParser";

export const useHtmlReactParserWithNavigate = (aemBaseUrl: string) => {
  const { navigate, language } = useUniversalContext() as UniversalContext;
  const { setPopupUrl, setIsPopupVisible } = useCanadaPopUp();

  return (source: string) =>
    htmlReactParser(source, {
      navigate,
      aemBaseUrl,
      locale: language,
      setPopupUrl,
      setIsPopupVisible,
    });
};
